import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import ElementPlus from 'element-plus';
import './assets/styles/tailwind.css';
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/display.css'
import axios from 'axios';
import { ROUTES } from './config/constants';
import ja from 'element-plus/es/locale/lang/ja';


// 请求拦截器
axios.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem('token');
    if (token) {
      // 将token添加到请求头中
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  (response: any) => {
    return response;
  },
  (error: { response: { status: any; }; }) => {
    const status = error.response.status;
    if (status === 401) {
      router.push(`/${ROUTES.TOKEN_EXPIRED}`);
    } else if (status === 403) {
      router.push(`/${ROUTES.FORBIDDEN}`);
    } else if (status === 404) {
      router.push(`/${ROUTES.NOT_FOUND}`);
    } else if (status === 500) {
      router.push(`/${ROUTES.SERVER_ERROR}`);
    }
    return Promise.reject(error);
  }
);


if ('serviceWorker' in navigator && 'PushManager' in window) {
  window.addEventListener('load', () => {
      navigator.serviceWorker.register('/firebase-messaging-sw.js')
          .then((registration) => {
              console.log('Service Worker registered with scope:', registration.scope);
          })
          .catch((error) => {
              console.error('Service Worker registration failed:', error);
          });
  });
}

const app = createApp(App);

app.use(router);
app.use(ElementPlus, { locale: ja });
// app.config.globalProperties.$messaging = messaging
app.mount('#app');